module.exports = __webpack_public_path__ + "img/bkex.962bfde4.png";